'use es6';

import TinyMCE from 'tinymce';
import { hsimageConfig } from '../constants/image';
import { __HS_CONTENT_GENERATION } from '../constants/plugins';
import { getImagePluginSetting } from '../utils/image';
import { initContentGenerationSelectionPlugin } from './selection';
import { initContentGenerationAutocompletePlugin } from './generative';
import { getPluginSetting } from '../utils';
import { ADD_AI_IMAGE_COMMAND, CONTENT_ASSISTANT_SETTINGS, hsContentAssistantConfig } from '../constants/hscontentgeneration';
import { addControls } from './controls';
function hsContentGenerationPlugin(editor) {
  const {
    [hsContentAssistantConfig.IS_DISABLED]: isDisabled,
    [hsContentAssistantConfig.SELECTION_COMMANDS]: selectionCommands = [],
    [hsContentAssistantConfig.BRAND_VOICE_OPTIONS]: brandVoiceOptions = {}
  } = getPluginSetting(editor, CONTENT_ASSISTANT_SETTINGS, {});
  let {
    [hsContentAssistantConfig.SLASH_COMMANDS]: slashCommands = []
  } = getPluginSetting(editor, CONTENT_ASSISTANT_SETTINGS, {});
  const useImageGenerationSlashCommand = getImagePluginSetting(editor, hsimageConfig.USE_IMAGE_GENERATION_SLASH_COMMAND);
  if (!useImageGenerationSlashCommand) {
    slashCommands = slashCommands.filter(command => command.id !== ADD_AI_IMAGE_COMMAND.id);
  } else if (!slashCommands.find(command => command.id === ADD_AI_IMAGE_COMMAND.id)) {
    // temporary, until all apps inject IMAGE in slashCommands config
    slashCommands = [...slashCommands, ADD_AI_IMAGE_COMMAND];
  }
  addControls(editor, slashCommands, selectionCommands, isDisabled, brandVoiceOptions);
  if (!isDisabled) {
    initContentGenerationSelectionPlugin(editor, selectionCommands, brandVoiceOptions);
    initContentGenerationAutocompletePlugin(editor, slashCommands, brandVoiceOptions);
  }
}
export const HS_CONTENT_GENERATION = __HS_CONTENT_GENERATION;
TinyMCE.PluginManager.add(HS_CONTENT_GENERATION, hsContentGenerationPlugin);